

import documentIcon from "../../../assets/icons/SidebarDocumentIcon.svg";
import campaignsIcon from "../../../assets/icons/SidebarCampaignsIcon.svg";
import assessmentIcon from "../../../assets/icons/SidebarAssessmentIcon (2).svg";
import quizIcon from "../../../assets/icons/SidebarQuizIcon (2).svg";
import supportIcon from "../../../assets/icons/SidebarSupportIcon (2).svg";
import faqIcon from "../../../assets/icons/FaqIcon.svg";
import ClickRatesLineChart from "./charts/ClickRatesChart";
import ClickRatesBarChart from "./charts/ClickRatesBarchart";
import StatsCard from "./StatsCard";
import MailStatCard from "./MailStatCard";
import MenuCard from "./MenuCard";

const Dashboard = () => {
  const navItems = [
    { name: "Knowledge Management", icon: documentIcon, path: "/knowledge-management" },
    { name: "Campaigns", icon: campaignsIcon, path: "/campaigns" },
    { name: "Assessment", icon: assessmentIcon, path: "/assessment" },
    { name: "Quiz", icon: quizIcon, path: "/quiz" },
    { name: "Support", icon: supportIcon, path: "/support" },
      { name: "FAQ", icon: faqIcon, path: "/faq" },
  ];

  return (
    <div className="w-full pt-2">
      {/* NAV ICON GRID */}
      <div
        className="
          grid
          grid-cols-2
          sm:grid-cols-3
          md:grid-cols-4
          lg:grid-cols-6
          xl:grid-cols-6
          gap-3
          mb-3
        "
      >
        {navItems.map((item, idx) => (
          <MenuCard
            key={idx}
            name={item.name}
            icon={item.icon}
            path={item.path}
          />
        ))}
      </div>

      {/* STATS CARDS */}
      <div>
        <StatsCard/>
      </div>

      {/* MAIL STATS */}
      <div>
        <MailStatCard />
      </div>

      {/* CHARTS */}
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        <ClickRatesLineChart />
        <ClickRatesBarChart />
      </div>
    </div>
  );
};

export default Dashboard;